export const startWithLoginCookie = 'start_with_auth_form'
